<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>

        <BreadcrumbItem to="/appcenter?sgnav=ptsz">平台设置</BreadcrumbItem>
        <BreadcrumbItem to="">角色管理</BreadcrumbItem>

      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">
      <Col span='14'>
      <Alert show-icon type='error'>
        <Icon type="ios-bulb-outline" slot="icon"></Icon>
        创建系统权限使用角色，可添加每个角色的相应人员，用于应用中心各项功能的权限配置。
      </Alert>
      </Col>

      <ul class='conheadRight'>
        <i-button type="error" @click='sModal(-1)'>新建角色</i-button>
      </ul>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'>
      </tablePage>
    </section>
    <Modal v-model="newConfig" :title='rolename' :mask-closable='false' width='462px'>

      <Form label-position="top" ref='formCustom'>

        <Transfer :data="alluser" ref='refTransfer' :target-keys="targetUser" id='teachTransfer' filterable
          :not-found-text="''" :reverse-operation='true' :titles="['待选列表', '已选列表']" @on-change="changeUsers"
          :selected-keys='selectUser'></Transfer>
      </Form>

      <div slot="footer" style='position:relative;'>

        <Button type="default" @click='newConfig = false' icon="md-close">取消</Button>
        <Button type="info" @click='newConfigMethod' icon="md-checkmark-circle-outline">保存</Button>
        <!-- <Button type="primary" @click='pipeGw' icon="md-checkmark-circle-outline" v-if='targetKeys.length>0'>流转文件</Button> -->
      </div>
    </Modal>
    <Modal v-model='menuModal' @on-ok='updateMenu'>
      <Tree :data="menuData" show-checkbox expand ref='schoolTree' @on-check-change='getTree'></Tree>
      <!-- @on-check-change='getTree' -->
    </Modal>
    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
  </section>
</template>

<script>
import utils from '../utils/getSchoolData.js'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
import inputtree from './inputTree'
export default {
  name: 'sysRolerole',
  components: {
    tablePage,
    bemodal,
    inputtree
  },
  data () {
    return {
      checkTreeIds: '',
      menuModal: false,
      menuData: [],
      newConfig: false,
      alluser: [],
      targetUser: [],
      selectUser: [],
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      formData: [
        ['sysRole/detial', 'sysRole/saveRole', 'sysRole/delete.do'],
        [
          {
            type: 'input',
            title: '角色名称',
            name: 'name',
            model: ''
          },
          {
            type: 'textarea',
            title: '备注',
            name: 'descr',
            model: ''
          },
          {
            type: 'switch',
            title: '是否可用',
            name: 'state',
            model: true
          },
          {
            type: 'remark',
            title: '功能说明：',
            name: '',
            model: '角色主要对智慧校园平台每一项功能的权限定义。创建角色后，请选择该角色所关联的人员，在应用中心配置时，可定义每一个应用按钮所对应的角色，相关角色人员可使用该应用功能。'
          },
          {
            type: 'hidden',
            children: [{
              name: 'id',
              model: ''
            }, {
              name: 'schoolid',
              model: ''
            }]
          }
        ]
      ],
      queryData: ['sysRole/dataList',
        [{
          title: '角色名称',
          key: 'name',
          render: (h, params) => {

            return h('strong', decodeURI(params.row.name))
          }
        },
        {
          title: '是否可用',
          key: 'state',
          width: 150,
          align: 'center',
          render: (h, params) => {                      // 根据条件判断内容重写
            var c = params.row
            if (c.state == 1) {

              return h('span', {
                style: {
                  color: "#ed4c78",
                  backgroundColor: "rgba(237,76,120,.1)",
                  padding: "2px 8px",
                  borderRadius: '7px',
                  fontSize: '11px',
                  display: 'inline-block',
                }

              }, '不可用')
            } else if (c.state == 0) {
              return h('span', {
                style: {
                  color: "rgb(0, 201, 219)",
                  backgroundColor: "rgba(0, 201, 219, 0.1)",
                  padding: "2px 8px",
                  borderRadius: '7px',
                  fontSize: '11px',
                  display: 'inline-block',
                }

              }, '可用')
            }
          },
        },
        {
          title: '人员信息',
          key: '',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {

                  textDecoration: 'underline',
                  color: '#2d8cf0',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                },
                on: {
                  click: () => {
                    //console.log(params)
                    this.curRowGuid = params.row.id
                    var checkUser = [], that = this;
                    this.rolename = params.row.name
                    this.alluser = JSON.parse(JSON.stringify(this.initAlluser))
                    // 清空穿梭框搜索条件
                    this.$refs.refTransfer.$children[0].query = ''
                    this.$refs.refTransfer.$children[2].query = ''
                    // 清空穿梭框复选框
                    this.$refs.refTransfer.$children[0].toggleSelectAll()
                    this.$refs.refTransfer.$children[2].toggleSelectAll()
                    this.selectUser = []
                    this.targetUser = []
                    this.axios.get('sysRole/queryUserByRole', { params: { roleId: params.row.id, schoolid: that.curSchoolid } }).then(res => {
                      //console.log(res)
                      var data = res.data
                      for (var i = 0; i < data.length; i++) {
                        checkUser.push(data[i]['guid'])
                      }
                      that.targetUser = checkUser
                    })

                    this.newConfig = true
                  }
                }
              }, '管理/查看人员')

            ]);
          }
        },
        {
          title: '菜单管理',
          key: '',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {

                  textDecoration: 'underline',
                  color: '#2d8cf0',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                },
                on: {
                  click: () => {
                    //console.log(params)
                    this.showMenu(params.row)
                  }
                }
              }, '菜单配置')

            ]);
          }
        },
        {
          title: '添加时间',
          key: 'createTime',
          width: 200,
          align: 'center',
        },
        {
          title: '修改时间',
          key: 'updateTime',
          width: 200,
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 110,
          align: 'center'
        }

        ]
      ],
      searchParam: {
        notice: '',
      },
      rolename: '人员配置',
      curRowGuid: -1,
      curSchoolid: -1,
      issearch: -1,
      initAlluser: [],
    }
  },
  mounted () {
    var that = this
    utils.getTeachData().then(res => {

      that.alluser = JSON.parse(res)
      that.initAlluser = JSON.parse(JSON.stringify(that.alluser))
    })
    var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    this.curSchoolid = userInfo.schoolid
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    utils.getMenuData().then(res => {
      //console.log(res)
      that.initmenuData = JSON.parse(JSON.stringify(res))
      that.menuData = res
    })
  },
  methods: {
    showMenu (row) {
      this.menuModal = true
      this.curRole = row
      var that = this
      that.menuData = JSON.parse(JSON.stringify(that.initmenuData))
      this.axios.get('sysRole/getId', { params: { id: row.id } }).then(res => {
        //console.log(that.menuData,res.data.menuIds,'sysRole/menuRole')
        that.filterDeviceTree(that.menuData, res.data.menuIds, true)
      })
    },
    updateMenu () {
      var that = this
      var param = {
        menubtn: that.checkTreeIds,
        name: this.curRole.name,
        state: 0,
        id: this.curRole.id
      }
      //console.log(param)

      this.axios.post('sysRole/save', param).then(res => {
        that.$Message.info('更新成功')
      })
    },
    getTree (tree) {
      var tree = this.$refs.schoolTree.getCheckedAndIndeterminateNodes()
      var arr = []
      var that = this
      tree.map(function (val, index) {
        arr.push(val['id'])
      })
      that.checkTreeIds = arr.join(',')
    },
    filterDeviceTree (tree, ids, ischeck) {

      var that = this;
      for (var i = 0; i < tree.length; i++) {
        for (var j = 0; j < ids.length; j++) {
          if (tree[i]['id'] == ids[j]) {

            if (ischeck && tree[i]['children'].length == 0) {
              // tree[i]['checked'] = true
              that.$set(tree[i], "checked", true);
            } else {
              that.$set(tree[i], "selected", true);
              // tree[i]['selected'] = true
            }

            tree[i]['expand'] = true
          }
        }
        if (tree[i]['children'].length > 0) {
          this.filterDeviceTree(tree[i]['children'], ids, ischeck)
        }
      }

      this.menuData = tree

      //this.getParId(tree,that.checkPid)
    },
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid, data) {
      //console.log(guid, 'guid', this.formData[0][0])
      this.reloadTmep = Math.random()
      guid = guid ? guid : data.id
      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      this.formData[0][0] = this.formData[0][0] + '?id=' + guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
    },
    reloadTable () {
      this.issearch = Math.random()
    },
    changeUsers (val, c, d) {
      //console.log(val)
      this.targetUser = val
    },
    newConfigMethod () {

      var that = this
      var param = {
        roleid: this.curRowGuid,
        selPersons: this.targetUser.join(','),
      }
      //console.log(param)

      this.axios.post('sysRole/rolePerson', param).then(res => {
        //console.log(res)
        if (res.success) {
          that.$Message.success(res.msg)
          that.newConfig = false
        }
      })
    },
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
}

.demo-upload-list {
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
  margin-right: 10px;
}

#teachTransfer {
  height: 350px;
}
</style>
